import {AdventureImagesModel }from './AdventureImagesModel';
import { AdventureItineraryModel} from './AdventureItineraryModel'
import {AdventureIncludedModel }from './AdventureIncludedModel'

export class AdventuresModel{
    id?: number;
    titleAr?:string;
    titleEn?:string;
    titleFr?:string;
    descriptionAr?:string;
    descriptionEn?:string;
    descriptionFr?:string;
    countryId?: number;
    numberOfDays?: number;

    latitude?: number;
    longitude?: number;
    cityId?: number;
    userId?: number;
    date?: Date;
    adventureImagesList?:AdventureImagesModel[]
    adventureItineraryList?:AdventureItineraryModel[]
    adventureIncludedList?:AdventureItineraryModel[]
    
    images?:string;
    countryNameAr?:string;
    countryNameEn?:string;
    cityNameAr?:string;
    cityNameEn?:string;



    constructor(item?:AdventuresModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.images = item.images? item.images:'';
        this.titleAr = item.titleAr? item.titleAr:'';
        this.titleEn = item.titleEn? item.titleEn:'';
        this.titleFr = item.titleFr? item.titleFr:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.descriptionFr = item.descriptionFr? item.descriptionFr:'';
        this.countryId = item.countryId? item.countryId:0;
        this.numberOfDays = item.numberOfDays? item.numberOfDays:0;
        this.latitude = item.latitude? item.latitude:0;
        this.longitude = item.longitude? item.longitude:0;
        this.cityId = item.cityId? item.cityId:0;
        this.userId = item.userId? item.userId:0;
        this.date = item.date? item.date:new Date();
        this.adventureImagesList = item.adventureImagesList? item.adventureImagesList:[];
        this.adventureItineraryList = item.adventureItineraryList? item.adventureItineraryList:[];
        this.adventureIncludedList = item.adventureIncludedList? item.adventureIncludedList:[];
        this.countryNameAr = item.countryNameAr? item.countryNameAr:'';
        this.countryNameEn = item.countryNameEn? item.countryNameEn:'';
        this.cityNameAr = item.cityNameAr? item.cityNameAr:'';
        this.cityNameEn = item.cityNameEn? item.cityNameEn:'';

    }

}